/**
 * Dynamically updated version string. Accessable via GetSharedSettings() in `src/shared/common/src/common/GetSharedSettings.ts`.
 *
 * - 1.0.0 is the base version and should be updated manually as needed.
 * - The suffix is the short Git commit hash.
 * - See .husky\pre-push.
 *
 * Workflows should ignore changes to this file so builds only occur when actual code changes happen.
 *
 * - This allows each package to have a version corresponding to the commit that built it.
 * - It also prevents building a package when only other packages have changed.
 */
export const VERSION = '1.0.0-64c20ab';
